import { observer } from 'mobx-react'
import React, { FC } from 'react'

import {
  ExtendedColumnKey,
  FilterRenderingComponentProps,
} from '@new/__global/components/FiltersFramework/_types'
import { FilterStore } from '@new/__global/components/FiltersFramework/FilterStore'

interface FilterRendererProps<ValueType> {
  filterComponent: FC<FilterRenderingComponentProps<ValueType>>
  id: string
  label: string
  filterStore: FilterStore
  onChange?: (selectedValues?: ValueType) => void // used for cache
  isSidebarFilter?: boolean
  customComponentProps?: any
  filterAsColumnKey?: ExtendedColumnKey
}

export function _FilterRenderer<ValueType>({
  id,
  label,
  filterStore,
  filterComponent: FilterComponent,
  onChange,
  customComponentProps,
  filterAsColumnKey,
}: FilterRendererProps<ValueType>) {
  const activeValue = filterStore.computedRouteParams[id].get()

  return (
    <FilterComponent
      id={id}
      label={label}
      onChange={onChange || (value => filterStore.setFilterValue(id, value))}
      activeValue={activeValue}
      initialValue={activeValue}
      getFilterValue={filterStore.getFilterValue}
      onShowFilterAsColumn={
        filterAsColumnKey
          ? () => filterStore.setExtendedColumnsConfig(filterAsColumnKey)
          : undefined
      }
      showFilterAsColumn={
        filterAsColumnKey ? filterStore.getActiveExtendedColumnKey(filterAsColumnKey) : undefined
      }
      {...customComponentProps}
    />
  )
}

export const FilterRenderer = observer(_FilterRenderer)
